// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.patient-form-page {
  box-sizing: border-box;
  min-height: 100%;
  padding: 0 0 48px;
  background: #F8FAFC;
}

.patient-form-page__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding: 20px 24px;
  border-bottom: 1px solid #E2E8F0;
  background: #ffffff;
}

.patient-form-page__title-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}

.patient-form-page__back {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin-top: 2px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #ffffff;
  color: #334155;
  cursor: pointer;
  flex-shrink: 0;
}

.patient-form-page__back:hover {
  background: #F8FAFC;
  border-color: #CBD5E1;
}

.patient-form-page__title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #0F172A;
  line-height: 1.25;
}

.patient-form-page__subtitle {
  margin: 4px 0 0;
  font-size: 13px;
  color: #64748B;
  line-height: 1.45;
  max-width: 52ch;
}

.patient-form-page__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.patient-form-page__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.patient-form-page__btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.patient-form-page__btn--ghost {
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #334155;
}

.patient-form-page__btn--ghost:hover:not(:disabled) {
  background: #F8FAFC;
  border-color: #CBD5E1;
}

.patient-form-page__btn--primary {
  border: 1px solid #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);
}

.patient-form-page__btn--primary:hover:not(:disabled) {
  background: #0284C7;
  border-color: #0284C7;
}

.patient-form-page__canvas {
  max-width: 1152px;
  margin: 0 auto;
  padding: 24px;
}

.patient-form-page__hint {
  margin: 0 0 16px;
  font-size: 12px;
  color: #64748B;
  line-height: 1.45;
}

.patient-form-page__hint span {
  color: #EF4444;
  font-weight: 600;
}

@media (max-width: 720px) {
  .patient-form-page__header {
    padding: 16px;
  }

  .patient-form-page__canvas {
    padding: 16px;
  }

  .patient-form-page__title {
    font-size: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/NewPatient/style.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".patient-form-page {\n  box-sizing: border-box;\n  min-height: 100%;\n  padding: 0 0 48px;\n  background: #F8FAFC;\n}\n\n.patient-form-page__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  padding: 20px 24px;\n  border-bottom: 1px solid #E2E8F0;\n  background: #ffffff;\n}\n\n.patient-form-page__title-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  min-width: 0;\n}\n\n.patient-form-page__back {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  margin-top: 2px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #334155;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.patient-form-page__back:hover {\n  background: #F8FAFC;\n  border-color: #CBD5E1;\n}\n\n.patient-form-page__title {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  color: #0F172A;\n  line-height: 1.25;\n}\n\n.patient-form-page__subtitle {\n  margin: 4px 0 0;\n  font-size: 13px;\n  color: #64748B;\n  line-height: 1.45;\n  max-width: 52ch;\n}\n\n.patient-form-page__actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.patient-form-page__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 14px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n.patient-form-page__btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.patient-form-page__btn--ghost {\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #334155;\n}\n\n.patient-form-page__btn--ghost:hover:not(:disabled) {\n  background: #F8FAFC;\n  border-color: #CBD5E1;\n}\n\n.patient-form-page__btn--primary {\n  border: 1px solid #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);\n}\n\n.patient-form-page__btn--primary:hover:not(:disabled) {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n.patient-form-page__canvas {\n  max-width: 1152px;\n  margin: 0 auto;\n  padding: 24px;\n}\n\n.patient-form-page__hint {\n  margin: 0 0 16px;\n  font-size: 12px;\n  color: #64748B;\n  line-height: 1.45;\n}\n\n.patient-form-page__hint span {\n  color: #EF4444;\n  font-weight: 600;\n}\n\n@media (max-width: 720px) {\n  .patient-form-page__header {\n    padding: 16px;\n  }\n\n  .patient-form-page__canvas {\n    padding: 16px;\n  }\n\n  .patient-form-page__title {\n    font-size: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
